import React, { useEffect, useState } from 'react';
import PopupModal from '../../components/modal/PopupModal';
import { logout } from '../../redux/slice/authSlice';
import { useDispatch } from 'react-redux';

const Logout = () => {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const handleLogout = async () => {
      setShowSuccessModal(true);

      await new Promise(resolve => setTimeout(resolve, 2000));

      await dispatch(logout());
    };

    handleLogout();
  }, [dispatch]);

  return (
    <div className="flex items-center justify-center mt-12 flex-col">
      <PopupModal
        time={2000}
        isOpen={showSuccessModal}
        message="Logged out successfully"
        type="success"
        onClose={() => setShowSuccessModal(false)}
      />
    </div>
  );
};

export default Logout;